import React from "react";
import { Icon } from "@iconify/react/dist/iconify.js";

const AgendaDeleteConfirmModal = ({
  show,
  onHide,
  onConfirm,
  submitting = false,
  eventTitle = "",
}) => {
  if (!show) return null;

  return (
    <div
      className="modal fade show d-block"
      tabIndex={-1}
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      onClick={(e) => {
        if (e.target === e.currentTarget && !submitting) onHide();
      }}
    >
      <div className="modal-dialog modal-sm modal-dialog-centered">
        <div className="modal-content radius-16 bg-base border-0 shadow-lg">
          <div className="modal-body text-center px-24 py-32">
            <div className="w-64-px h-64-px bg-danger-100 d-flex align-items-center justify-content-center radius-circle mx-auto mb-20">
              <Icon
                icon="mdi:trash-can-outline"
                className="text-danger-600"
                style={{ fontSize: "32px" }}
              />
            </div>
            <h5 className="fw-semibold mb-8">¿Eliminar evento?</h5>
            <p className="text-secondary-light text-sm mb-0">
              Estás a punto de eliminar{" "}
              <strong className="text-primary-light">"{eventTitle}"</strong>. Esta
              acción no se puede deshacer.
            </p>
          </div>
          <div className="modal-footer justify-content-center px-24 py-16 border-top gap-12">
            <button
              type="button"
              className="btn btn-outline-secondary radius-8 px-24"
              onClick={onHide}
              disabled={submitting}
            >
              Cancelar
            </button>
            <button
              type="button"
              className="btn btn-danger radius-8 px-24 d-flex align-items-center gap-6"
              onClick={onConfirm}
              disabled={submitting}
            >
              {submitting ? (
                <>
                  <div
                    className="spinner-border spinner-border-sm"
                    role="status"
                  />
                  Eliminando...
                </>
              ) : (
                <>
                  <Icon icon="mdi:trash-can-outline" className="text-lg" />
                  Eliminar
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgendaDeleteConfirmModal;
